import { SvgIcon, SxProps } from "@mui/material";
import LargeXMarkSvg from "jsx:../../../Images/Icons/FontAwesome/regular/xmark-large.svg";

export function LargeRegularXMarkIcon(props: SxProps) {
    return <SvgIcon component={LargeXMarkSvg} inheritViewBox sx={props} />;
}
